import { observer } from "mobx-react-lite";

import { IMenuItem } from "@/app/routing/types";
import { useLateInitContext } from "@/shared/hooks/use-late-init-context";

import { NavigationMenuContext } from "../../model/navigation-menu/context/navigation-menu";

import { Indicator } from "./menu-indicator";
import { MenuTooltip } from "./menu-tooltip";

export const MenuIcon = observer(
	({ menuItem, children }: { menuItem?: IMenuItem; children: React.ReactNode }) => {
		const state = useLateInitContext(NavigationMenuContext);

		if (!menuItem) return children;

		const indication = state.getIndication(menuItem.indicationName);

		return (
			<>
				{menuItem.topDivider && (
					<div className="border-t border-ant-color-split absolute top-0 left-0 right-0" />
				)}

				<MenuTooltip tooltipMessage={indication?.message} />

				<span className="inline-flex h-full relative items-center">
					{indication?.statusName && <Indicator statusName={indication.statusName} />}

					{children}
				</span>
			</>
		);
	}
);
